export const Footer = () => {
    return <footer>

    </footer>
}